import React from 'react';

import { Check, X } from 'lucide-react';

interface CheckboxFieldProps {
  id: string;
  value: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  subtext?: string | React.ReactNode;
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({
  id,
  value,
  onChange,
  disabled,
  subtext,
}) => (
  <>
    {subtext && <span className="mb-5">{subtext}</span>}
    <label className="relative flex items-center gap-2 cursor-pointer text-slate-500 dark:text-cream">
      <input
        id={id}
        type="checkbox"
        checked={value}
        onChange={onChange}
        className="relative w-16 h-8 transition-colors appearance-none cursor-pointer peer rounded-2xl bg-slate-300 dark:bg-seam
              after:absolute after:left-0 after:top-0 after:h-8 after:w-8 after:rounded-full
              after:bg-slate-500 dark:after:bg-slate-500 after:transition-all checked:bg-slate-300
              dark:checked:bg-slate-600  checked:after:left-8 checked:after:bg-primary
              dark:checked:after:bg-primary focus:outline-none disabled:cursor-not-allowed"
        disabled={disabled}
      />
      <div
        className="flex absolute left-8 top-1 h-6 w-6 items-center justify-center text-slate-500 dark:text-cream opacity-100
              transition-opacity peer-checked:opacity-0"
      >
        <X className="h-5 w-5" />
      </div>
      <div
        className="flex absolute left-1 top-1 h-6 w-6 items-center justify-center text-secondary dark:text-secondary opacity-0
              transition-opacity peer-checked:opacity-100"
      >
        <Check className="h-5 w-5" />
      </div>
    </label>
  </>
);

export default CheckboxField;
